// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__84z4I","savePackageButton":"ClientWallet_savePackageButton__3lZHl"};